<ng-select

  style="width: 100%"
  #select
  (change)="emitSelectedApp($event)"
  class="custom"
  placeholder="App toevoegen..."
  >
  @for (app of availableApps; track app) {
    <ng-option [value]="app">
      {{ app.name }}
    </ng-option>
  }
</ng-select>
